import React from 'react';
import Accordion from "../../components/accordion/Accordion";
import DateSelector from '../../lib/DateSelector/DateSelector';
import '../../../styles/modules/waiver-reporting.less';
import moment from 'moment';

interface WaiverReportingFormProps {
  accordionOpen: boolean;
  setAccordionOpen: (open: boolean) => void;
  startTime: string;
  setStartTime: (date: string) => void;
  endTime: string;
  setEndTime: (date: string) => void;
  formKey: number;
  submitForm: (formIsValid: boolean) => void;
  resetForm: () => void;
}

const WaiverReportingForm: React.FC<WaiverReportingFormProps> = ({
  accordionOpen,
  setAccordionOpen,
  startTime,
  setStartTime,
  endTime,
  setEndTime,
  formKey,
  submitForm,
  resetForm,
}) => {

  return (
    <div className="row search col-md-12">
      <div className="search-form">
        <Accordion
          id="waiver-reporting-accordion"
          className='uib-accordion'
          panels={[
            {
              id: 'reporting-criteria',
              title: 'REPORTING CRITERIA',
              show: accordionOpen,
              children: (
                <form
                  name="searchform"
                  role="form"
                  noValidate
                  onSubmit={(e) => {
                    e.preventDefault();
                    submitForm(e.currentTarget.checkValidity());
                  }}
                >
                  <div className="row">
                    <div className="col-sm-12 col-md-9 col-lg-9">
                      <div className="row">
                      <div className={'form-group row col-xs-12 col-sm-6 col-md-4 resolve-by waiver-reporting-datepicker'}>
                        <DateSelector
                          key={`start-${formKey}`}
                          label="Start Month:"
                          value={startTime}
                          dateFormat="MMMM yyyy"
                          showMonthYearPicker={true}
                          onChange={(date) => {
                            setStartTime(moment(date).format('YYYY-MM-DD'));
                            setAccordionOpen(true);
                          }}
                          placeholderText="MM-YYYY"
                        />
                        </div>
                        <div className={'form-group row col-xs-12 col-sm-6 col-md-4 resolve-by waiver-reporting-datepicker'}>
                        <DateSelector
                          key={`end-${formKey}`}
                          label="End Month:"
                          value={endTime}
                          dateFormat="MMMM yyyy"
                          showMonthYearPicker={true}
                          onChange={(date) => {
                            setEndTime(moment(date).format('YYYY-MM-DD'));
                            setAccordionOpen(true);
                          }}
                          placeholderText="MM-YYYY"
                        /></div>
                        <div className="col-md-4"></div>
                      </div>
                    </div>
                  </div>
                  <div className="row form-group-sep">
                    <div className="col-md-8"></div>
                    <div className="col-md-4 search-button">
                      <div className="form-group waiver-reporting-form-button">
                        <input
                          className="btn btn-default button-clear"
                          type="button"
                          value="CLEAR"
                          onClick={() => {
                            resetForm();
                            setAccordionOpen(true);
                          }}
                        />
                        <input
                          className="btn btn-default button-action"
                          type="submit"
                          value="REPORT"
                        />
                      </div>
                    </div>
                  </div>
                </form>
              ),
            },
          ]}
        />
      </div>
    </div>
  );
};

export default WaiverReportingForm;